import { Box, TextField } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import { useLocation } from "react-router-dom";

const ViewNonUpdatedContract = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="NON UPDATED CONTRACT"
            subtitle="View a non updated contract details"
          />

          <Formik>
            {() => (
              <form>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    type="text"
                    label="Contract Phase"
                    value={
                      location.state.nonUpdatedContractDetails.phaseofcontract
                    }
                    name="phaseofcontract"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Contract Type"
                    value={location.state.nonUpdatedContractDetails.typeofcontract}
                    name="typeofcontract"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Contract Status Id"
                    value={location.state.nonUpdatedContractDetails.ContractStatusId}
                    name="ContractStatusId"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Total Amount"
                    value={location.state.nonUpdatedContractDetails.TotalAmount}
                    name="TotalAmount"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Status"
                    value={location.state.nonUpdatedContractDetails.TotalTakenAmount}
                    name="TotalTakenAmount"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="FullName"
                    value={location.state.nonUpdatedContractDetails.FullName}
                    name="FullName"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Contract Code"
                    value={location.state.nonUpdatedContractDetails.ContractCode}
                    name="ContractCode"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Customer Code"
                    value={location.state.nonUpdatedContractDetails.CustomerCode}
                    name="CustomerCode"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Company Name"
                    value={location.state.nonUpdatedContractDetails.CompanyName}
                    name="CompanyName"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Start Date"
                    value={location.state.nonUpdatedContractDetails.StartDate}
                    name="StartDate"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Outstanding Amount"
                    value={location.state.nonUpdatedContractDetails.OutstandingAmount}
                    name="OutstandingAmount"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Past Due Amount"
                    value={location.state.nonUpdatedContractDetails.PastDueAmount}
                    name="PastDueAmount"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Past Due Days"
                    value={location.state.nonUpdatedContractDetails.PastDueDays}
                    name="PastDueDays"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Expected End Date"
                    value={location.state.nonUpdatedContractDetails.ExpectedEndDate}
                    name="ExpectedEndDate"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Last Snapshot Date"
                    value={location.state.nonUpdatedContractDetails.LastSnapshotDate}
                    name="LastSnapshotDate"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Subscriber"
                    value={location.state.nonUpdatedContractDetails.Subscriber}
                    name="Subscriber"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

export default ViewNonUpdatedContract;

